export default __webpack_public_path__ + "static/media/steadfastfaith.80082206.png";